import React from 'react';

const footerContainerStyle = {
  width: '100%',
  borderTop: '1px solid rgba(255,255,255,0.15)',
  background: 'rgba(0,0,0,0.6)',
  backdropFilter: 'blur(6px)',
  color: '#ddd',
};

const footerInnerStyle = {
  maxWidth: '1200px',
  margin: '0 auto',
  padding: '16px 20px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  flexWrap: 'wrap',
  gap: '12px',
  fontSize: '14px',
};

const linkGroupStyle = {
  display: 'flex',
  gap: '16px',
  alignItems: 'center',
};

const linkStyle = {
  color: '#9fd3ff',
  textDecoration: 'none',
};

const linkHoverStyle = {
  textDecoration: 'underline',
};

const copyrightStyle = {
  opacity: 0.8,
};

export default function Footer() {
  const [hovered, setHovered] = React.useState('');
  const year = new Date().getFullYear();

  return (
    <footer style={footerContainerStyle}>
      <div style={footerInnerStyle}>
        <div style={linkGroupStyle}>
          <a
            href="https://www.isadorancreed.com/privacy"
            target="_blank"
            rel="noopener noreferrer"
            style={{ ...linkStyle, ...(hovered === 'privacy' ? linkHoverStyle : {}) }}
            onMouseEnter={() => setHovered('privacy')}
            onMouseLeave={() => setHovered('')}
          >
            Privacy Policy
          </a>
          <span style={{ opacity: 0.4 }}>|</span>
          <a
            href="https://www.isadorancreed.com/terms"
            target="_blank"
            rel="noopener noreferrer"
            style={{ ...linkStyle, ...(hovered === 'terms' ? linkHoverStyle : {}) }}
            onMouseEnter={() => setHovered('terms')}
            onMouseLeave={() => setHovered('')}
          >
            Terms of Service
          </a>
        </div>
        <div style={copyrightStyle}>
          © {year} Isadoran Creed
        </div>
      </div>
    </footer>
  );
}





